const router = Mach.requireModule('Router');

const navigateBack = () => {
  router.navigateBack();
};

export { navigateBack };
